import { isUndefinedOrNull } from '../../TypeHelpers';
import where from './where';
export default function lastOrDefault(iterable, predicate) {
    if (!isUndefinedOrNull(predicate)) {
        iterable = where(iterable, predicate);
    }
    let current;
    for (const item of iterable) {
        current = item;
    }
    if (isUndefinedOrNull(current)) {
        return null;
    }
    return current;
}
